// src/firebase-config.js

import { initializeApp } from "firebase/app"
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBytS0sp8jfgMj3qlmQAENTXRq0MKUH-Lk",
  authDomain: "trystreampal.firebaseapp.com",
  projectId: "trystreampal",
  storageBucket: "trystreampal.appspot.com",
  messagingSenderId: "584040420088",
  appId: "1:584040420088:web:6b655418cbb0458939a10d",
  measurementId: "G-XGFZX9FCPT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);